import { render } from "./DynamicInputText.vue?vue&type=template&id=678b1670&ts=true"
import script from "./DynamicInputText.vue?vue&type=script&lang=ts"
export * from "./DynamicInputText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicInputText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "678b1670"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('678b1670', __exports__)) {
    api.reload('678b1670', __exports__)
  }
  
  module.hot.accept("./DynamicInputText.vue?vue&type=template&id=678b1670&ts=true", () => {
    api.rerender('678b1670', render)
  })

}


export default __exports__